import { Component, ViewChild, OnInit, Input, Output, EventEmitter } from '@angular/core'
import { jqxTreeComponent } from 'jqwidgets-ng/jqxtree'

@Component({
    selector: 'jqtreemenu',
    templateUrl: `jq-treemenu.component.html`
})
export class JQTreeMenu implements OnInit {
    @ViewChild('treeReference') treemenu: jqxTreeComponent
    @Output() elementClicked: EventEmitter<any> = new EventEmitter()
    data: any = []
    jqx: any

    source = {
        datatype: 'json',
        datafields: [{ name: 'MenuID' }, { name: 'MenuPage' }, { name: 'ParentID' }, { name: 'ParentName' }, { name: 'SectionID' }],
        id: 'id',
        localdata: this.data
    }
    dataAdapter = new jqx.dataAdapter(this.source)

    /*  source: any = {
          dataFields: [
              { name: 'OrgID', type: 'number' },
              { name: 'ParentOrgId', type: 'number' },
              { name: 'OrgShortName', type: 'string' },
              { name: 'OrgName', type: 'string' },
              { name: 'EffectiveDate', type: 'date' },
              { name: 'TerminationDate', type: 'date' },
              { name: 'OrgType', type: 'string' }
          ],
          hierarchy:
              {
                  keyDataField: { name: 'OrgID' },
                  parentDataField: { name: 'ParentOrgId' }
              },
          dataType: 'json',
          id: 'OrgID',
          localData: this.org
      } */

    /*  columns = [{ text: 'OrgID', dataField: 'OrgID', width: 200 },
      { text: 'OrgShortName', dataField: 'OrgShortName', width: 160 },
      { text: 'OrgName', dataField: 'OrgName', width: 120 },
      { text: 'EffectiveDate', dataField: 'OrgEffectiveDate', cellsFormat: 'd', width: 120 },
      { text: 'TerminationDate', dataField: 'OrgTerminationDate', width: 250 },
      { text: 'OrgType', dataField: 'OrgType', width: 120 }
      ] */

    constructor() {}

    public onTreeMenuDataLoad(data: any[]): void {
        // update databound
        this.source.localdata = data
        this.dataAdapter.dataBind()
        this.treemenu.attrSource = data
    }

    ngOnInit(): void {}

    select(event: any): void {
        this.elementClicked.emit(event)
        // this.ContentPanel.nativeElement.innerHTML = "<div style='margin: 10px;'>" + event.args.element.id + "</div>";
    }
}
